import { render, staticRenderFns } from "./ConstructionProjectDetailsView.vue?vue&type=template&id=0841fc3d&scoped=true&"
import script from "./ConstructionProjectDetailsView.vue?vue&type=script&lang=js&"
export * from "./ConstructionProjectDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionProjectDetailsView.vue?vue&type=style&index=0&id=0841fc3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0841fc3d",
  null
  
)

/* custom blocks */
import block0 from "./ConstructionProjectDetailsView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports